import { defineRecipe } from "@chakra-ui/react";

// Bark version - to be unified later
export const checkMarkRecipe = defineRecipe({
  className: "chakra-checkmark",
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0",
    focusVisibleRing: "outside",
    verticalAlign: "middle",
    borderWidth: "2px",
    borderRadius: "md",
    backgroundColor: "base.200",
    _hover: {
      cursor: "pointer",
    },
    borderColor: "lines",
    color: "lines",
    _icon: {
      boxSize: "full",
      width: "36px",
      height: "36px",
      color: "button.border.hollow",
    },
    _disabled: {
      _hover: {
        cursor: "not-allowed",
      },
    },
  },
  variants: {
    variant: {
      outline: {
        _invalid: {
          borderColor: "error.element",
        },
        _checked: {
          "&:is([data-state=checked], [data-state=indeterminate])": {
            bg: "base.200",
            borderColor: "button.border.hollow",
          },
          _icon: {
            _dark: {
              color: "action.600",
            },
          },
        },
        _disabled: {
          layerStyle: "disabled",
          backgroundColor: "base.400",
          borderColor: "lines",
          cursor: "not-allowed",
          color: "text.soft",
        },
      },
    },
    size: {
      lg: {
        height: "48px",
        width: "48px",
      },
    },
  },
});

// Existing styling
export const legacyCheckmarkRecipe = defineRecipe({
  className: "chakra-checkmark",
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0",
    color: "white",
    cursor: "pointer",
    borderWidth: "2px",
    borderColor: "gray.300",
    verticalAlign: "middle",
    borderRadius: "l1",
    focusVisibleRing: "outside",
    _icon: {
      boxSize: "80%",
    },
    _checked: {
      "&:is([data-state=checked], [data-state=indeterminate])": {
        bg: "burntYellow.500",
        color: "white",
        border: "none",
      },
    },
  },
  variants: {
    variant: {
      mpXlStyleMark: {
        height: "48px",
        width: "48px",
        borderWidth: "2px",
        borderStyle: "solid",
        borderColor: "gray.300",
        borderRadius: "6px",
        focusVisibleRing: "none",
        _checked: {
          "&:is([data-state=checked])": {
            bg: "white",
            color: "deepBlue.500",
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "deepBlue.500",
            borderRadius: "6px",
          },
          animation: "fade-in 300ms ease-out",
        },
      },
    },
    size: {
      xs: {
        boxSize: "3",
      },
      sm: {
        boxSize: "4",
        mt: "1px",
      },
      md: {
        boxSize: "5",
        p: "0.5",
      },
      lg: {
        boxSize: "6",
        p: "0.5",
      },
    },
  },
});
